import { useHistory, useParams } from "react-router-dom";
import { bTag, CoreContainer, LayoutConst } from "../../../core";
import { HSESansTitleCoolEpicMegoGena } from "../../../_deziiign/hsedesign/components/IndexTitle";
import { useTranslation } from "react-i18next";
import { useTagsList } from "../../hooks/api/useTagsList";
import { FlexBox, useBreakpoint } from "@brg/ui";
import { BTag } from "../../../core/components";
import { CreateLinkTo } from "../../constants/linkTo";
import { isRequired } from "../../modals/selectTagsModal/support/isRequired";
import React, { useCallback, useEffect, useRef, useState, useMemo } from "react";
import {AppTester} from "../../../supporting";
import { TAGS_LEVEL } from "shared/modals/selectTagsModal/tagsSearchResultsItem";
import FoundChildrens from "shared/modals/selectTagsModal/FoundedChildrens";
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import styled from "styled-components";
import { Tag } from "@brg/api";
import { LoaderSpinner } from "shared/modals/artzLegalsModal/LoaderAnimation";
import { slashPathIndex } from "shared/constants/enginePaths";
import { getPathContext } from "core/helpers/getPathContext";

export const GalllleryLink = styled.a`
  max-width: 100%;
  line-height: 0.8em;
  margin-bottom: 0px !important;
  margin-right: 0px !important;
`

const LoadMoreTrigger = styled.div`
  height: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
`

const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`

const TagCategoryView = () => {
  const { id, childId } = useParams<{ id: string, childId: string }>();
  const history = useHistory();
  const activeTag = useRef<any>(null);
  const [t, setT] = useState(Date.now());
  const [forceUpdate, setForceUpdate] = useState(0);
  const isMobile = useBreakpoint(LayoutConst.screen.m);
  const [search, setSearch] = useState<string>('')
  const isGeograffee = AppTester.isGeograffee();
  const isGalllleryArt = AppTester.isGalllleryArt();
  const isGeoDafes = AppTester.isGeoDafes();

  // Бесконечный скролл
  const [visibleItems, setVisibleItems] = useState(150);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const loadMoreRef = useRef<HTMLDivElement>(null);

  const { i18n: { language } } = useTranslation();

  const {application, mode: env} = getPathContext();


  const filter = {
    // entityTypes: tagEntity,
    isHeaderIgnored: true,
    status: [0],
    lang: language,
    groupIds: [id],
    // @ts-ignore
    isHeaderIgnored: true,
  };

  useEffect(() => {
    setT(Date.now());
    setVisibleItems(150);
  }, [id])

  const [tags, isLoading] = useTagsList(filter, language, t);

  const tag = useMemo(() => {
    const parentTag = tags.find(({ tagId }) => tagId === id);
    if (!childId) return parentTag;
    return parentTag?.additionalTags?.find(({ tagId }) => tagId === childId)
  }, [childId, id, tags])

  const visibleTags = useMemo(() => {
    if (!tag?.additionalTags) return [];
    return tag.additionalTags.slice(0, visibleItems);
  }, [tag?.additionalTags, visibleItems]);

  const hasMoreItems = useMemo(() => {
    if (!tag?.additionalTags) return false;
    return visibleItems < tag.additionalTags.length;
  }, [tag?.additionalTags, visibleItems]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && hasMoreItems && !isLoadingMore) {
          setIsLoadingMore(true);
          setTimeout(() => {
            setVisibleItems(prev => prev + 150);
            setIsLoadingMore(false);
          }, 300);
        }
      },
      {
        rootMargin: '100px',
        threshold: 0.1
      }
    );

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }

    return () => {
      if (loadMoreRef.current) {
        observer.unobserve(loadMoreRef.current);
      }
    };
  }, [hasMoreItems, isLoadingMore]);

  const onChildrenTagClick = useCallback((tag: Tag) => {
    history.push(CreateLinkTo.tag(tag.tagId));
  }, [history])

  const onTagArrowClick = useCallback((ev: any, id?: string) => {
    activeTag.current = id;
    setForceUpdate(prev => prev + 1);
  }, [])

  const onSetActiveTagClick = useCallback((id: string, flag: boolean) => {
    if (flag || flag === undefined) {
        activeTag.current = id
    } else {
        activeTag.current = null
    }
  }, [])

  const categorySearchLocal = useCallback((e: any) => {
    const vl = e.target.value
    if (vl !== '') {
      setSearch(vl.trim());
    }
}, [])

const getSerializeHref = (tagId: string) => {
  if (isGalllleryArt) {
    return CreateLinkTo.externalTagArtz(tagId)
  }
  const splittedCtx = Object.entries(
    slashPathIndex['deziiign/mediiia'])?.find(([k,v]) => v === application)?.[0]

  if (splittedCtx && typeof splittedCtx === 'string') {
    return `/${splittedCtx}/tag/${tagId}`
  }

  return  CreateLinkTo.tag(tagId)
}

//Заглушка
const isSelected = useCallback((tag: Tag) => (false), [])

  const tagList = useMemo(() => visibleTags.map((tag) => {
    const isTagHaveChild= tag?.level === TAGS_LEVEL.children;
    const currentActiveTag = activeTag.current || '';
    const tagIsOpen = currentActiveTag === tag?.tagId;
    const isTagsShadowNeed = !!currentActiveTag && !tagIsOpen;
    const href = getSerializeHref(tag?.tagId)

    if (isTagHaveChild) {
      return (
        <FoundChildrens
        item={tag}
        // search={search}
        selected={isSelected}
        parent={isTagHaveChild}
        children_item={tag?.additionalTags}
        onClick={onChildrenTagClick}
        onTagArrowClick={onTagArrowClick}
        // onSetActiveTagClick={(flag) => onSetActiveTagClick(tag?.tagId, flag)}
        onSearchInputChange={categorySearchLocal}
        key={tag?.tagId}
        opacity={isTagsShadowNeed}
        moreNeeded={false}
        canOpenTag={tagIsOpen}
        mobileArrowVisible={isMobile}
        />
      )
    }
    
    return (
      <GalllleryLink key={tag.tagId} href={href} target={isGalllleryArt ? "_blank" : "_self"} rel="noopener noreferrer">
        {/*@ts-ignore*/}
        <BTag tag={tag} educational={tag.isEducationTag} organization={tag.isTeamTag} opacity={isTagsShadowNeed}>
          {bTag.title(tag)}
        </BTag>
      </GalllleryLink>
    )
  }), [
    visibleTags, 
    isMobile,
    activeTag,
    isSelected,
    onSetActiveTagClick,
    categorySearchLocal,
    onTagArrowClick,
    onChildrenTagClick,
    forceUpdate
  ])

  return (
    <CoreContainer bottomOffset={44}>
     {
      isLoading? 
      <FlexBox justify="center" width={'100%'}>
        <LoaderSpinner />
      </FlexBox>
      :
      <>
        <HSESansTitleCoolEpicMegoGena isAlumni isDark={isGeograffee && !isGeoDafes}>
          {tag?.name}
        </HSESansTitleCoolEpicMegoGena>
        <FlexBox offsetTop={24}>
          <BTagsGridNew noLimitMaxHeight>
            {tagList}
          </BTagsGridNew>
        </FlexBox>
        {hasMoreItems && (
          <LoadMoreTrigger ref={loadMoreRef}>
            {isLoadingMore && <LoadingSpinner />}
          </LoadMoreTrigger>
        )}
      </>}
    </CoreContainer>
  )
}

export default TagCategoryView;import { useHistory, useParams } from "react-router-dom";
import { bTag, CoreContainer, LayoutConst } from "../../../core";
import { HSESansTitleCoolEpicMegoGena } from "../../../_deziiign/hsedesign/components/IndexTitle";
import { useTranslation } from "react-i18next";
import { useTagsList } from "../../hooks/api/useTagsList";
import { FlexBox, useBreakpoint } from "@brg/ui";
import { BTag } from "../../../core/components";
import { CreateLinkTo } from "../../constants/linkTo";
import { isRequired } from "../../modals/selectTagsModal/support/isRequired";
import React, { useCallback, useEffect, useRef, useState, useMemo } from "react";
import {AppTester} from "../../../supporting";
import { TAGS_LEVEL } from "shared/modals/selectTagsModal/tagsSearchResultsItem";
import FoundChildrens from "shared/modals/selectTagsModal/FoundedChildrens";
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import styled from "styled-components";
import { Tag } from "@brg/api";
import { LoaderSpinner } from "shared/modals/artzLegalsModal/LoaderAnimation";
import { slashPathIndex } from "shared/constants/enginePaths";
import { getPathContext } from "core/helpers/getPathContext";

export const GalllleryLink = styled.a`
  max-width: 100%;
  line-height: 0.8em;
  margin-bottom: 0px !important;
  margin-right: 0px !important;
`

const LoadMoreTrigger = styled.div`
  height: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
`

const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`

const TagCategoryView = () => {
  const { id, childId } = useParams<{ id: string, childId: string }>();
  const history = useHistory();
  const activeTag = useRef<any>(null);
  const [t, setT] = useState(Date.now());
  const [forceUpdate, setForceUpdate] = useState(0);
  const isMobile = useBreakpoint(LayoutConst.screen.m);
  const [search, setSearch] = useState<string>('')
  const isGeograffee = AppTester.isGeograffee();
  const isGalllleryArt = AppTester.isGalllleryArt();
  const isGeoDafes = AppTester.isGeoDafes();

  // Бесконечный скролл
  const [visibleItems, setVisibleItems] = useState(150);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const loadMoreRef = useRef<HTMLDivElement>(null);

  const { i18n: { language } } = useTranslation();

  const {application, mode: env} = getPathContext();


  const filter = {
    // entityTypes: tagEntity,
    isHeaderIgnored: true,
    status: [0],
    lang: language,
    groupIds: [id],
    // @ts-ignore
    isHeaderIgnored: true,
  };

  useEffect(() => {
    setT(Date.now());
    setVisibleItems(150);
  }, [id])

  const [tags, isLoading] = useTagsList(filter, language, t);

  const tag = useMemo(() => {
    const parentTag = tags.find(({ tagId }) => tagId === id);
    if (!childId) return parentTag;
    return parentTag?.additionalTags?.find(({ tagId }) => tagId === childId)
  }, [childId, id, tags])

  const visibleTags = useMemo(() => {
    if (!tag?.additionalTags) return [];
    return tag.additionalTags.slice(0, visibleItems);
  }, [tag?.additionalTags, visibleItems]);

  const hasMoreItems = useMemo(() => {
    if (!tag?.additionalTags) return false;
    return visibleItems < tag.additionalTags.length;
  }, [tag?.additionalTags, visibleItems]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && hasMoreItems && !isLoadingMore) {
          setIsLoadingMore(true);
          setTimeout(() => {
            setVisibleItems(prev => prev + 150);
            setIsLoadingMore(false);
          }, 300);
        }
      },
      {
        rootMargin: '100px',
        threshold: 0.1
      }
    );

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }

    return () => {
      if (loadMoreRef.current) {
        observer.unobserve(loadMoreRef.current);
      }
    };
  }, [hasMoreItems, isLoadingMore]);

  const onChildrenTagClick = useCallback((tag: Tag) => {
    history.push(CreateLinkTo.tag(tag.tagId));
  }, [history])

  const onTagArrowClick = useCallback((ev: any, id?: string) => {
    activeTag.current = id;
    setForceUpdate(prev => prev + 1);
  }, [])

  const onSetActiveTagClick = useCallback((id: string, flag: boolean) => {
    if (flag || flag === undefined) {
        activeTag.current = id
    } else {
        activeTag.current = null
    }
  }, [])

  const categorySearchLocal = useCallback((e: any) => {
    const vl = e.target.value
    if (vl !== '') {
      setSearch(vl.trim());
    }
}, [])

const getSerializeHref = (tagId: string) => {
  if (isGalllleryArt) {
    return CreateLinkTo.externalTagArtz(tagId)
  }
  const splittedCtx = Object.entries(
    slashPathIndex['deziiign/mediiia'])?.find(([k,v]) => v === application)?.[0]

  if (splittedCtx && typeof splittedCtx === 'string') {
    return `/${splittedCtx}/tag/${tagId}`
  }

  return  CreateLinkTo.tag(tagId)
}

//Заглушка
const isSelected = useCallback((tag: Tag) => (false), [])

  const tagList = useMemo(() => visibleTags.map((tag) => {
    const isTagHaveChild= tag?.level === TAGS_LEVEL.children;
    const currentActiveTag = activeTag.current || '';
    const tagIsOpen = currentActiveTag === tag?.tagId;
    const isTagsShadowNeed = !!currentActiveTag && !tagIsOpen;
    const href = getSerializeHref(tag?.tagId)

    if (isTagHaveChild) {
      return (
        <FoundChildrens
        item={tag}
        // search={search}
        selected={isSelected}
        parent={isTagHaveChild}
        children_item={tag?.additionalTags}
        onClick={onChildrenTagClick}
        onTagArrowClick={onTagArrowClick}
        // onSetActiveTagClick={(flag) => onSetActiveTagClick(tag?.tagId, flag)}
        onSearchInputChange={categorySearchLocal}
        key={tag?.tagId}
        opacity={isTagsShadowNeed}
        moreNeeded={false}
        canOpenTag={tagIsOpen}
        mobileArrowVisible={isMobile}
        />
      )
    }
    
    return (
      <GalllleryLink key={tag.tagId} href={href} target={isGalllleryArt ? "_blank" : "_self"} rel="noopener noreferrer">
        {/*@ts-ignore*/}
        <BTag tag={tag} educational={tag.isEducationTag} organization={tag.isTeamTag} opacity={isTagsShadowNeed}>
          {bTag.title(tag)}
        </BTag>
      </GalllleryLink>
    )
  }), [
    visibleTags, 
    isMobile,
    activeTag,
    isSelected,
    onSetActiveTagClick,
    categorySearchLocal,
    onTagArrowClick,
    onChildrenTagClick,
    forceUpdate
  ])

  return (
    <CoreContainer bottomOffset={44}>
     {
      isLoading? 
      <FlexBox justify="center" width={'100%'}>
        <LoaderSpinner />
      </FlexBox>
      :
      <>
        <HSESansTitleCoolEpicMegoGena isAlumni isDark={isGeograffee && !isGeoDafes}>
          {tag?.name}
        </HSESansTitleCoolEpicMegoGena>
        <FlexBox offsetTop={24}>
          <BTagsGridNew noLimitMaxHeight>
            {tagList}
          </BTagsGridNew>
        </FlexBox>
        {hasMoreItems && (
          <LoadMoreTrigger ref={loadMoreRef}>
            {isLoadingMore && <LoadingSpinner />}
          </LoadMoreTrigger>
        )}
      </>}
    </CoreContainer>
  )
}

export default TagCategoryView;